import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { navSelector } from 'store/modules/competition-nav/selectors';
import { setOtherMatches } from 'common/store/modules/competition-nav/init';
import { SwitchInput } from '../../SwitchInput';
import { getTranslation } from 'common/react/utils/translations';

export const OtherMatchesToggle = ({ style, labelRightPosition = false }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);

    return (
        <div className="competition-nav__other-matches-toggle" style={style}>
            <SwitchInput
                labelRightPosition={labelRightPosition}
                id="other-matches-toggle"
                label={getTranslation('label.show-other-matches')}
                isChecked={nav.otherMatches.isActive}
                onChange={(isActive) => {
                    dispatch(
                        setOtherMatches({
                            navItem: 'otherMatches',
                            value: isActive
                        })
                    );
                }}
            />
        </div>
    );
};

OtherMatchesToggle.propTypes = {
    style: PropTypes.object,
    labelRightPosition: PropTypes.bool
};
